import React from 'react';
import { NamedLink } from '../../../components';
import css from './SectionTeam.module.css';

const PersonCard = (props) => {
    const {
        picture,
        name,
        title,
        description,
    } = props;

    return <div className={css.picture}>
        <img width="100%" src={picture} />
        <div className={css.info}>
            <div className={css.personName}>
                {name}
            </div>
            <div className={css.personTitle}>
                {title}
            </div>
            <div>
                <NamedLink name="CMSPage" params={{ pageId: "team" }} className={css.readMore}>
                    Read more
                </NamedLink>
            </div>
        </div>
    </div>
};

export default PersonCard;
